import React, { ReactNode } from "react";

import { IMember } from "src/app/project/ProjectTypes";
import avatarPlaceholder from "src/images/avatar-purple.svg";
import { ReactComponent as TrashCanIcon } from "src/images/trash-can.svg";
import { Img } from "../Img/Img";

import "./MemberList.scss";

interface MembersListActions {
  deleteMember?: (memberId: string) => void;
}

interface Props {
  header: string | ReactNode;
  members: IMember[];
  actions?: MembersListActions;
}

export const MemberList = (props: Props) => {
  const { header, members, actions } = props;

  return (
    <div className="member-list">
      <div className="member-list__header">{header}</div>
      <div className="member-list__content">
        {members.map((member) => (
          <div className="member-list__content-item" key={member.id}>
            <Img
              className="member-list__content-item-avatar"
              src={member.avatarUrl}
              alt="avatar"
              fallbackImageSrc={avatarPlaceholder}
            />
            <div className="member-list__content-item-info">
              <span className="member-list__content-item-name">
                {member.name}
              </span>
              <span className="member-list__content-item-email">
                {member.email}
              </span>
            </div>

            {actions && (
              <div className="member-list__content-item-buttons">
                {actions.deleteMember && (
                  <button
                    onClick={() =>
                      actions.deleteMember && actions.deleteMember(member.id)
                    }
                    type="button"
                  >
                    <TrashCanIcon />
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
